import getUsedLocale from '@/utils/get-used-locale'
import { State } from './state'
import { Broadcast } from '@/types/Event.type'

export function isAdmin(state: any) {
    if (state.decodedToken?.roles) {
        return !!state.decodedToken.roles.find((role: string) => ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'].includes(role))
    }

    return false
}

export function isConnected(state: any): boolean {
    return !!state.token
}

export function getLocale(state: any) {
    return state.me?.locale || getUsedLocale()
}

export function isBroadcasting(state: any): Broadcast | null {
    return state.broadcast
}

export function getPublisher(state: any): OT.Publisher | null {
    return state.publisher || null
}

export function hasAudio(state: any): boolean {
    return state?.publisher?.stream?.hasAudio || false
}

export function hasVideo(state: any): boolean {
    return state?.publisher?.stream?.hasVideo || false
}

export function greenRoomCameraPublisher(state: State): OT.Publisher | null {
    return (
        state.greenroom.publishers.find(publisher => publisher?.stream && publisher.stream?.videoType !== 'screen') ||
        null
    )
}

export function greenRoomScreenPublisher(state: State): OT.Publisher | null {
    return (
        state.greenroom.publishers.find(publisher => publisher?.stream && publisher.stream?.videoType === 'screen') ||
        null
    )
}

export function liveCameraPublisher(state: State): OT.Publisher | null {
    return (
        state.live.publishers.find(publisher => publisher?.stream && publisher.stream?.videoType !== 'screen') || null
    )
}

export function liveScreenPublisher(state: State): OT.Publisher | null {
    return (
        state.live.publishers.find(publisher => publisher?.stream && publisher.stream?.videoType === 'screen') || null
    )
}

export function amIInGreenRoom(state: State): boolean {
    return (
        !!state.greenroom.publishers.find(
            publisher => publisher.session?.sessionId === state.backstageInfos?.greenRoomSessionId
        ) || false
    )
}

export function amIInLiveRoom(state: State): boolean {
    return (
        !!state.live.publishers.find(
            publisher => publisher.session?.sessionId === state.backstageInfos?.liveSessionId
        ) || false
    )
}

export function liveSessionConnectionList(state: State): OT.Connection[] {
    return state.live.streams
        .filter(stream => stream.videoType !== 'screen') // case where no webcam
        .map(stream => stream.connection)
}

export function greenRoomConnectionList(state: State): OT.Connection[] {
    return state.greenroom.streams
        .filter(stream => stream.videoType !== 'screen') // case where no webcam
        .map(stream => stream.connection)
}

export function waitingBackstageConnectionList(state: State, getters: any): OT.Connection[] {
    return state.live.connections.filter(conn => {
        if (getters.amIInGreenRoom && conn.data === state.greenroom.session?.connection?.data) {
            return false
        }

        if (getters.amIInLiveRoom && conn.connectionId === state.live.session?.connection?.connectionId) {
            return false
        }

        let idx = getters.liveSessionConnectionList.findIndex(
            (liveConn: OT.Connection) => liveConn.connectionId === conn.connectionId
        )

        if (idx > -1) {
            return false
        }

        // Use data instead of "connectionId" because of P2P
        idx = getters.greenRoomConnectionList.findIndex((greenConn: OT.Connection) => greenConn.data === conn.data)

        if (idx > -1) {
            return false
        }

        return true
    })
}
